<footer class="row">
	<br>
</footer>
<div style="font-size: 23px !important;" class="grupo-2">
	<small><p style="color:#fff; text-align:center; 
		vertical-align: middle;">Universidad Gerardo Barrios | UGB. {{ 'footer.copyright' | translate:{year: dateObj | date:'y'} }}</p></small>
</div>